var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1 mb-2"},[_c('div',{class:_vm.clazz},[(_vm.title)?_c('div',{staticClass:"card-header"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }